import { gql } from 'urql';

const GetReactivationTokenInfo = gql`
  query GetTokenInfo {
    getTokenInfo {
      ... on TokenInfoError {
        __typename
        code
        message
        title
      }
      ... on TokenInfoSuccess {
        __typename
        closedCustomerIds
        closedIdentityIds
        customerId
        identityId
        reactivationUserId
        sub
        userAccountClosed
      }
    }
  }
`;

export default GetReactivationTokenInfo;
